import layout from '@/layout'

export default {
  path: '/log',
  component: layout,
  redirect: '/log/manage',
  name: 'logInfo',
  meta: {
    title: '日志管理',
    icon: 'log'
  },
  children: [
    {
      path: '/log/manage',
      component: () => import('@/views/log-manage/log/index.vue'),
      meta: {
        title: '日志',
        icon: 'book'
      }
    },
    {
      path: '/log/:id',
      component: () => import('@/views/log-manage/log/info'),
      meta: {
        title: '日志详情'
      }
    }
  ]
}
